import Loader from "../../commons/loader/Loader";
import useGuest from "./useGuest";

export default function Guest() {
  const { status } = useGuest();
  return <Loader />;
}
